"use client";
import { createContext, useContext } from "react";

interface MultiStepFormContextType {
  currentStep: number;
  totalSteps: number;
  nextStep: () => void;
  prevStep: () => void;
  canGoToStep: (step: number) => boolean;
  goToStep: (step: number) => void;
}

const MultiStepFormContext = createContext<MultiStepFormContextType | undefined>(undefined);

export const useMultiStepFormSteps = () => {
  const context = useContext(MultiStepFormContext);
  if (!context) {
    throw new Error("useMultiStepFormSteps must be used within a MultiStepFormProvider");
  }
  return context;
};

export const MultistepFormStepProvider = MultiStepFormContext.Provider;
